<template>
    <rkm-form
        v-if="model"
        ref="RkmForm"
        show-legend
    >
        <rkm-row>
            <rkm-col cols="6">
                <rkm-form-select
                    :options="form.unidade"
                    disabled
                    label="Unidade"
                    text-field="nomeFantasia"
                    v-model="model.unidadeId"
                    value-field="id"
                />
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-select
                    :options="form.infraestrutura"
                    disabled
                    label="Local de atendimento"
                    text-field="nome"
                    v-model="model.infraestruturaId"
                    value-field="id"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="6">
                <rkm-form-select
                    :options="form.setores"
                    :validations="validations.centroCustoId"
                    label="Setor"
                    show-default-option
                    text-field="nome"
                    v-model="model.centroCustoId"
                    value-field="centroCustoId"
                />
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-select
                    :options="form.telas"
                    :validations="validations.telaId"
                    label="Tela"
                    show-default-option
                    text-field="nome"
                    v-model="model.telaId"
                    value-field="id"
                />
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Mixins.
import { error, repository, stringCase } from '@/mixins'

// Vuex.
import { mapActions, mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters({ lotacao: 'getLotacao' }),
        validations() {
            return {
                centroCustoId: { required: true },
                telaId: { required: true },
            }
        },
    },
    created() {
        this.repositories =  {
            opcaoChamada: this.getConectaSusRepository('painelSenha.opcaoChamada')
        }
    },
    data: () => ({
        form: null,
        model: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            if (this.id) {
                this.repositories.opcaoChamada.edit(this.id)
                    .then(response => {
                        this.form = Object.assign(
                            {
                                unidade: [{
                                    id: this.lotacao.infraestrutura.unidade.id,
                                    nomeFantasia: this.lotacao.infraestrutura.unidade.nomeFantasia,
                                }],
                                infraestrutura: [{
                                    id: this.lotacao.infraestrutura.id,
                                    nome: this.lotacao.infraestrutura.nome,
                                }],
                            },
                            response.data.form,
                        )

                        this.model = Object.assign(
                            {
                                unidadeId: this.lotacao.infraestrutura.unidade.id,
                                infraestruturaId: this.lotacao.infraestrutura.id,
                            },
                            response.data.model,
                        )
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            } else {
                this.repositories.opcaoChamada.create()
                    .then(response => {
                        this.form = Object.assign(
                            {
                                unidade: [{
                                    id: this.lotacao.infraestrutura.unidade.id,
                                    nomeFantasia: this.lotacao.infraestrutura.unidade.nomeFantasia,
                                }],
                                infraestrutura: [{
                                    id: this.lotacao.infraestrutura.id,
                                    nome: this.lotacao.infraestrutura.nome,
                                }],
                            },
                            response.data.form,
                        )

                        this.model = Object.assign(
                            {
                                unidadeId: this.lotacao.infraestrutura.unidade.id,
                                infraestruturaId: this.lotacao.infraestrutura.id,
                            },
                            response.data.model,
                        )
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(valid => {

                    if (!valid) return

                    this.setLoading()

                    if (this.model.id) {

                        this.repositories.opcaoChamada
                            .update(this.model.id, this.camelObjectKeysToSnakeRecursive(this.model))
                            .then(response => {
                                this.showSaveNotification()
                                this.$emit('save', response)
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())

                    } else {

                        this.repositories.opcaoChamada.store(this.camelObjectKeysToSnakeRecursive(this.model))
                            .then(response => {
                                this.showSaveNotification()
                                this.$emit('save', response)
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())
                    }
                })
        },
    },
    mixins: [ error, repository, stringCase ],
    mounted() {
        this.load()
    },
    props: {
        id: { type: [Number, String], default: null },
    },
}
</script>